import * as React from "react";
import * as Autosuggest from 'react-autosuggest';
import InputMask from 'react-input-mask';

import { Header, Navigation, Footer } from "../../../shared";
import { AdministrationMenu } from "../../shared/menu/AdministrationMenu";
import { TablePublishers } from './TablePublishers';
import "./PublishersRegister.scss";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Paper,
  Snackbar,
  SnackbarContent,
  Typography,
  FormGroup
} from '@material-ui/core';

import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import Rest from "../../../../services/Rest";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

const QUERY_SAVE_PUBLISHER = ` query savePublisherRegister($customFilter: PublisherFilter) { 
    savePublisherRegister(publisherFilter: $customFilter) { 
        cnpj, 
        id, 
        publisher, 
        id_father, 
        publisher_father
    } 
} `;

const QUERY_GET_PUBLISHER = ` query getPublisher($customFilter: PublisherFilter) { 
    getPublisher(publisherFilter: $customFilter) { 
        id,
        publisher
    } 
} `;

const QUERY_DELETE_PUBLISHER = `query deletePublisherRegister($customFilter: PublisherFilter) { 
    deletePublisherRegister(publisherFilter: $customFilter) { 
        cnpj, 
        id, 
        publisher, 
        id_father, 
        publisher_father
    } 
} `

// tslint:disable-next-line:no-empty-interface
export interface IPublishersRegisterProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPublishersRegisterState {
    alertMessage: string,
    alertOpened: boolean,
    alertType: string,
    fixedSuggestions: any[],
    publisher: {
        cnpj: string,
        id: number,
        id_father: number,
        publisher: string,
        publisher_father: string
    },
    suggestions: any[],
    value: string
}

export class PublishersRegister extends React.Component<IPublishersRegisterProps, IPublishersRegisterState> {

    private tablePublishers: React.RefObject<TablePublishers>;
    constructor(props: IPublishersRegisterProps) {
        super(props);
        this.tablePublishers = React.createRef();

        this.state = {
            alertMessage: '',
            alertOpened: false,
            alertType: 'success',
            fixedSuggestions:[],
            publisher: {
                cnpj: '',
                id: 0,
                id_father: 0,
                publisher: '',
                publisher_father: ''
            },
            suggestions: [],
            value: ''
        }

        this.searchPublisher = this.searchPublisher.bind(this);
        this.receivePublisherToEdit = this.receivePublisherToEdit.bind(this);
        this.receivePublisherToDelete = this.receivePublisherToDelete.bind(this);
    }
  
    public receivePublisherToEdit (publisher:any) {
        const publisherFormat = {
            cnpj: publisher.cnpj,
            id: parseInt(publisher.id, 10),
            id_father: publisher.id_father,
            publisher: publisher.publisher,
            publisher_father: publisher.publisher_father
        }
        this.setState( {publisher: publisherFormat} );
    }

    public receivePublisherToDelete (publisher:any) {
        const publisherFormat = {
            cnpj: publisher.cnpj,
            id: parseInt(publisher.id, 10),
            id_father: publisher.id_father,
            publisher: publisher.publisher,
            publisher_father: publisher.publisher_father
        }
        // this.setState( { publisher } );

        this.deletePublisher(publisherFormat);
    }

    public componentWillMount () {

        const body = {
            "operationName":"",
            "query": QUERY_GET_PUBLISHER
        };

        Rest.GraphqlPOST(body)
            .then( result  => {
                this.setState({ fixedSuggestions: result.data.data.getPublisher })
            });
    }

    
    public render() {

        const { value, suggestions } = this.state;

        // // Autosuggest will pass through all these props to the input.
        const inputProps = {
            onChange: this.onChange,
            placeholder: 'Editora Pai',
            value
        };

        return (
        <div className="publishers-register-page">
            <Header title={"Cadastro de Editoras"} name={"Administrativo"} link={"/dashboard"} />

            <Navigation name={"Cadastro de Editoras"}
                linkDefault={"/administration/publishers-register"}
                link={"/dashboard"}
                linkTitle={"Produtos"}
                painel={3}
                icon={<ChevronRightIcon />}
            />
        
            <div className="publishers-register-body">
                <AdministrationMenu paramIcon={<StoreMallDirectoryIcon />} />

                <div className="wrapper">
                    <Grid
                        container={true}
                        className="publishers-register-panel panel-grid"
                        spacing={16}
                    >
                        <Grid item={true} xs={12} >
                            <div>
                                <Paper className="publisher-panel">
                                    <Grid container={true} direction="column" spacing={16}>
                                        <Grid item={true}>
                                            <Snackbar
                                                anchorOrigin={{
                                                    horizontal: 'center',
                                                    vertical: 'center',
                                                }}
                                                open={this.state.alertOpened}
                                                autoHideDuration={4000}
                                                onClose={this.closeAlert}
                                            >
                                                <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                                            </Snackbar>

                                            <Card>
                                                <form>
                                                    <CardContent id="content-publisher">
                                                        <Typography variant="title" component="h2">
                                                            Editora
                                                        </Typography>
                                                    
                                                        <FormGroup row={true}>
                                                            <TextField
                                                                id="outlined-name-input"
                                                                label="Nome"
                                                                style={this.textFieldStyle()}
                                                                value={this.state.publisher.publisher}
                                                                onChange={this.handleChangeCadastro('publisher')}
                                                                type="text"
                                                                name="name"
                                                                autoComplete="text"
                                                                margin="normal"
                                                                className="formTextField"
                                                                required={true}
                                                            />

                                                            <InputMask 
                                                                mask="99.999.999/9999-99" 
                                                                name="cnpj"
                                                                value={this.state.publisher.cnpj}
                                                                onChange={this.handleChangeCadastro('cnpj')}
                                                            >
                                                                {() => 
                                                                    <TextField
                                                                        id="standard-cnpj-input"
                                                                        label="CNPJ"
                                                                        style={this.textFieldStyle()}
                                                                        type="text"
                                                                        autoComplete="text"
                                                                        margin="normal"
                                                                        className="formTextField"
                                                                    />
                                                                }
                                                            </InputMask>
                                                        </FormGroup>

                                                        <FormGroup row={true}>
                                                            <div className="autocomplete-input">
                                                                <Autosuggest
                                                                    getSuggestionValue={this.getSuggestionValue}
                                                                    inputProps={inputProps}
                                                                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                    onSuggestionSelected={this.onSuggestionSelected}
                                                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                    renderSuggestion={this.renderSuggestion}
                                                                    suggestions={suggestions}
                                                                />
                                                            </div>
                                                        </FormGroup>
                                                    </CardContent>
                                                    <CardActions>
                                                        <Button 
                                                            className="filter-dialog-clear" 
                                                            onClick={this.handleClearAllForm} 
                                                        >
                                                            Limpar
                                                        </Button>
                                                        <Button 
                                                            className="filter-dialog-close" 
                                                            onClick={this.searchPublisher.bind(this,null)} 
                                                            color="primary">
                                                            Pesquisar
                                                        </Button>
                                                        <Button 
                                                            variant="contained" 
                                                            className="filter-dialog-close" 
                                                            onClick={this.savePublisher} color="primary"
                                                        >
                                                            Salvar
                                                        </Button>
                                                    </CardActions>
                                                </form>
                                            </Card>
                                            <Card>
                                                <CardContent>
                                                    <TablePublishers 
                                                        receivePublisherToEdit={this.receivePublisherToEdit} 
                                                        receivePublisherToDelete={this.receivePublisherToDelete} 
                                                        ref={this.tablePublishers} 
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="publishers-register-footer">
                <Footer />
            </div>
        </div>
        );
    }

    private alertStyle = () => {
        return styles[this.state.alertType];
    }

    private textFieldStyle = () => {
        return Object.assign({}, styles.textField)
    }

    private searchPublisher = (previewPublisher:any) => {
        if(this!= null && this.tablePublishers != null && this.tablePublishers.current != null) {

            let dataToSearch = previewPublisher;
            if(!dataToSearch) {
                dataToSearch = this.state.publisher;
            }

            this.syncPublisherStatusValue("");
            this.tablePublishers.current.changeState(
                this.prepareDataToBack(dataToSearch));
        }
    }

    private validDataForSave = () => {
        let messageValidation = 'É obrigatório informar: ';

        if(!this.state.publisher.publisher) {
            messageValidation += "  Editora.";
        }

        if(messageValidation !== 'É obrigatório informar: ') {
            this.errorSavePublisher(messageValidation);
            return false;
        }

        return  true;
    }

    private prepareDataToBack(dataToSend:any) {
        const re = /[\.\/\-]/gi;
        
        if(dataToSend.cnpj) {
            dataToSend.cnpj = dataToSend.cnpj.replace(re, "");
        }

        return dataToSend;
    }

    private savePublisher = () => {
        this.syncPublisherStatusValue("");

        if (this.validDataForSave()) {
            let customFilter : any = {
                "cnpj": this.state.publisher.cnpj,
                "id": this.state.publisher.id,
                "id_father": this.state.publisher.id_father,
                "publisher": this.state.publisher.publisher,
                "publisher_father": this.state.publisher.publisher_father
            };

            customFilter = this.prepareDataToBack(customFilter);

            const body = {
                "operationName":"",
                "query":QUERY_SAVE_PUBLISHER,
                "variables": {customFilter}
            };
        
            Rest.GraphqlPOST(body)
                .then( result  => {
                    if(result.data.errors && !result.data.data.savePublisherRegister) {
                        this.errorSavePublisher("Falha ao salvar registro.");
                    } else {
                        this.publisherSuccessSaved();
                        this.preparePublisherFormAfterSave(result.data.data.savePublisherRegister.id_father);
                        setTimeout(
                            this.searchPublisher(null), 3000
                        );
                    }
                }).catch(err => {
                    let errorMessage = 'Falha ao salvar registro.';
                    if(err != null && err !== undefined && err.message !=null && err.message !== undefined && err.message !== "") {
                        errorMessage = err.message;
                    }
                    this.errorSavePublisher(errorMessage);
                });
        }
    }

    private deletePublisher = (publisher: any) => {
        this.syncPublisherStatusValue("");

        let customFilter : any = {
            "cnpj": publisher.cnpj,
            "id": publisher.id,
            "id_father": publisher.id_father,
            "publisher": publisher.publisher,
            "publisher_father": publisher.publisher_father
        };
        
        customFilter = this.prepareDataToBack(customFilter);

        const body = {
            "operationName":"",
            "query":QUERY_DELETE_PUBLISHER,
            "variables": {customFilter}
        };
    
        Rest.GraphqlPOST(body)
            .then( result  => {
                if(result.data.errors) {
                    this.errorSavePublisher("Falha ao excluir registro.");
                } else {
                    this.publisherSuccessDeleted();
                    // this.preparePublisherFormAfterSave(result.data.data.savePublisherRegister.id_father);
                    this.handleClearAllForm();
                    setTimeout(
                        this.searchPublisher(null), 3000
                    );
                }
            }).catch(err => {
                let errorMessage = 'Falha ao excluir registro.';
                if(err != null && err !== undefined && err.message !=null && err.message !== undefined && err.message !== "") {
                    errorMessage = err.message;
                }
                this.errorSavePublisher(errorMessage);
        });

    }

    private publisherSuccessSaved() {
        this.openAlert(true, 'success', 'Cadastro realizado com sucesso.');
    }

    private publisherSuccessDeleted() {
        this.openAlert(true, 'success', 'Exclusão sendo realizada. Isso pode demorar alguns segundos.');
    }

    private errorSavePublisher(msg: string) {
        this.openAlert(true, 'error', msg || 'Erro. Verifique se o email já existe e se a senha segue as regras para cadastro.');
    }

    private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
        this.setState({ alertType })
        this.setState({ alertMessage })
        this.setState({ alertOpened })
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }

    private handleChangeCadastro = (param: any) => (event: React.FormEvent<HTMLInputElement>) => {
        const publisher = Object.assign({}, this.state.publisher);
        publisher[param] = event.currentTarget.value;
        this.setState({ publisher });
    };

    private handleClearAllForm = () => {
        const publisher = {
            cnpj: '',
            id: 0,
            id_father: 0,
            publisher: '',
            publisher_father: ''
        };

        this.searchPublisher(publisher);

        this.setState({
            publisher,
            value: ''
        });
    }

    private preparePublisherFormAfterSave = (idFather: number) => {
        if(!idFather) {
            idFather = this.state.publisher.id_father;
        }

        this.setState({
            publisher: {
                cnpj: '',
                id: 0,
                id_father: idFather,
                publisher: '',
                publisher_father: this.state.publisher.publisher_father
            }
        });
    }

    private getSuggestions = (input:any) => {
        const inputValue = input.value.trim().toLowerCase();
        const inputLength = inputValue.length;

        const fixedSuggestions = this.state.fixedSuggestions;

        return fixedSuggestions.filter(sug => 
                sug.publisher.toLowerCase().slice(0, inputLength) === inputValue
            );
    };

    private getSuggestionValue = (suggestion:any) => suggestion.publisher;

    private renderSuggestion = (suggestion:any) => {
        return (
            <Paper className="suggestion">
                <span>
                    {suggestion.publisher}
                </span>
            </Paper>
        );
    }

    private onChange = (event:object, newValue:any) => {
        this.setState({
            value: newValue.newValue
        });
        this.syncPublisherStatusValue(newValue.newValue);
    };
    
    private onSuggestionsFetchRequested = (value:any) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };
    
    private onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    private onSuggestionSelected = (event:object, selected: any ) => {
        const publisher = Object.assign({}, this.state.publisher);
        publisher.id_father = selected.suggestion.id;
        publisher.publisher_father = selected.suggestion.publisher;

        this.setState({ publisher });
    }

    private syncPublisherStatusValue = (inputValue:string) => {

        if(!inputValue) {
            inputValue = this.state.value;
        }

        const publisher = Object.assign({}, this.state.publisher);

        if(publisher.publisher_father) {
            if(publisher.publisher_father !== inputValue) {
                publisher.id_father = 0;
                publisher.publisher_father = inputValue;
            }
        } else {
            publisher.id_father = 0;
            if(inputValue) {
                publisher.publisher_father = inputValue;
            }
        }

        this.setState( {publisher} );
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/registers/publishers/PublishersRegister.tsx